import React, { memo } from 'react';
import { map, get } from 'lodash';
import classNames from 'classnames';
import Card from './Card';
import styles from './index.module.scss';

interface Props {
  data: any[];
  className?: string;
}

const CardList = (props: Props): JSX.Element => {
  const { data, className } = props;

  return (
    <div className={classNames(styles.cardList, className)}>
      {
        map(data, (item, idx): JSX.Element => {
          return (
            <Card
              key={idx}
              icon={get(item, 'icon', '')}
              msg={get(item, 'msg', [])}
            />
          );
        })
      }
    </div>
  );
};

export default memo(CardList);